import React, { Fragment, useState } from 'react'
import { Form, Input, Button, Col, Typography, Radio, message, Row } from 'antd'
import './index.less'
import { Header } from '/components/Header/'
import api from 'services/api'
import {
  BoaCompra,
  FreeFire,
  LevelUp,
  RecargaCelular,
  Tibia,
  Bitcoin,
  PubgMobile,
} from './PageTwo/index'
import { FormConfirmation } from '../../components/FormConfirmation'

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
}

const layout = {
  labelCol: { xs: { span: 24 }, lg: { span: 7 } },
  wrapperCol: { xs: { span: 24 }, lg: { span: 8 } },
}

const serverErrorMessage =
  'Ocorreu um erro interno. Por favor, tente novamente em alguns minutos'

const questionOneLabel = (
  <Typography.Title level={4}>
    <span style={{ color: '#d60202' }}>*</span>1. Informe o número do pedido que
    nós enviamos para você com o link no Mercado Livre.
  </Typography.Title>
)

const questionTwoLabel = (
  <Typography.Title level={4}>
    <span style={{ color: '#d60202' }}>*</span>2. O seu pedido é ENTREGA PRIME?
    Atenção: Caso coloque a informação errada sua solicitação será
    desconsiderada e você terá que enviar um novo formulário
  </Typography.Title>
)

const questionThreeLabel = (
  <Typography.Title level={4}>
    <span style={{ color: '#d60202' }}>*</span>3. Qual o produto que você
    comprou?
  </Typography.Title>
)

export const ProductRelease = () => {
  const [answers, setAnswers] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [step, setStep] = useState(1)

  const handleChange = property => {
    return function(e) {
      if (e.preventDefault) e.preventDefault()
      const param = { [property]: e.target.value }
      setAnswers({ ...answers, ...param })
    }
  }

  const backToFirstPage = () => {
    setStep(1)
    setAnswers({})
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const { data } = await api.post(
        '/send-product-release-form-data',
        answers,
      )

      if (data.code == 'Internal server error')
        message.error(serverErrorMessage)
      else {
        message.success('Dados enviados!')
        setStep(3)
      }
    } catch (error) {
      message.error(serverErrorMessage)
    }

    setIsLoading(false)

    setAnswers({})
  }

  const handleClick = async () => {
    if (answers?.orderId && answers?.isPrime && answers?.product) setStep(2)
    else message.error('Preencha todos os campos')
  }

  return (
    <Fragment>
      <div id='container'>
        <div className='wrapper'>
          <div id='main' style={{ marginRight: '0px' }} className='tab'>
            <Header />

            <Col xs={{ span: 22, offset: 1 }} lg={{ span: 12, offset: 6 }}>
              <div className='form-wrapper'>
                {step === 3 ? (
                  <FormConfirmation />
                ) : (
                  <Form layout='vertical' onSubmit={handleSubmit}>
                    <Typography.Title
                      level={2}
                      style={{ marginBottom: '36px', textAlign: 'center' }}
                    >
                      GCM Games - Liberação de produto
                    </Typography.Title>
                    {step === 1 && (
                      <>
                        <Form.Item
                          name='orderId'
                          label={questionOneLabel}
                          {...layout}
                        >
                          <Input
                            type='text'
                            name='orderId'
                            value={answers?.orderId}
                            onChange={handleChange('orderId')}
                            required
                          />
                        </Form.Item>

                        <Form.Item label={questionTwoLabel}>
                          <Radio.Group onChange={handleChange('isPrime')}>
                            <Radio
                              defaultChecked
                              style={radioStyle}
                              value={'Sim'}
                            >
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Sim
                              </Typography.Text>
                            </Radio>
                            <Radio style={radioStyle} value={'Não'}>
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Não
                              </Typography.Text>
                            </Radio>
                          </Radio.Group>
                        </Form.Item>

                        <Form.Item label={questionThreeLabel}>
                          <Radio.Group onChange={handleChange('product')}>
                            <Radio
                              style={radioStyle}
                              value={'Recarga Free Fire'}
                            >
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Recarga Free Fire
                              </Typography.Text>
                            </Radio>
                            <Radio style={radioStyle} value={'Tibia'}>
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Tibia
                              </Typography.Text>
                            </Radio>
                            <Radio style={radioStyle} value={'Level Up'}>
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Level Up
                              </Typography.Text>
                            </Radio>
                            <Radio style={radioStyle} value={'Boa compra'}>
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Boa compra
                              </Typography.Text>
                            </Radio>
                            <Radio style={radioStyle} value={'Recarga Celular'}>
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Recarga Celular
                              </Typography.Text>
                            </Radio>
                            <Radio style={radioStyle} value={'Bitcoin'}>
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Bitcoin
                              </Typography.Text>
                            </Radio>
                            <Radio style={radioStyle} value={'Pubg Mobile'}>
                              <Typography.Text style={{ fontSize: '18px' }}>
                                Pubg Mobile
                              </Typography.Text>
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      </>
                    )}
                    {step === 2 &&
                      {
                        'Recarga Free Fire': (
                          <FreeFire
                            handleChange={handleChange}
                            answers={answers}
                          />
                        ),
                        Tibia: (
                          <Tibia
                            handleChange={handleChange}
                            answers={answers}
                          />
                        ),
                        'Level Up': (
                          <LevelUp
                            handleChange={handleChange}
                            answers={answers}
                          />
                        ),
                        'Boa compra': (
                          <BoaCompra
                            handleChange={handleChange}
                            answers={answers}
                          />
                        ),
                        'Recarga Celular': (
                          <RecargaCelular
                            handleChange={handleChange}
                            answers={answers}
                          />
                        ),
                        Bitcoin: (
                          <Bitcoin
                            handleChange={handleChange}
                            answers={answers}
                          />
                        ),
                        'Pubg Mobile': (
                          <PubgMobile
                            handleChange={handleChange}
                            answers={answers}
                          />
                        ),
                      }[answers?.product]}
                    <Row type='flex' justify='center'>
                      {step === 2 && (
                        <Col style={{ marginTop: '16px' }}>
                          <Button
                            type='primary'
                            className='btn btn-big'
                            onClick={backToFirstPage}
                          >
                            Anterior
                          </Button>
                        </Col>
                      )}

                      <Col style={{ marginTop: '16px' }}>
                        {step === 1 ? (
                          <Button
                            type='primary'
                            className='btn btn-big'
                            onClick={handleClick}
                          >
                            Próximo
                          </Button>
                        ) : (
                          <Button
                            type='primary'
                            className='btn btn-big'
                            htmlType='submit'
                            loading={isLoading}
                          >
                            Enviar
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Form>
                )}
              </div>
            </Col>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
